const mutations = {
    setServiceRequestChalansList(state, data) {
        state.serviceRequestChalansList = data;
    },
    setAllChalansList(state, list) {
        state.allChalans = list.rows;
        state.chalanMeta = list.meta;
    },
    setChalan(state, chalan) {
        state.serviceRequestChalan = chalan;
    },
    resetServiceRequestChalan(state) {
        state.serviceRequestChalan = {
            isInward: false,
            chalanItems: [
                {
                    name: "",
                    quantity: null,
                },
            ]
        }
    }
}

export default mutations